function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9985 8.99999L4.99854 8.97999L5.00139 6.98L19.0014 7L18.9985 8.99999ZM6.99996 11H17V13H6.99996V11ZM8.99663 15.02L14.9966 15L15.0033 17L9.0033 17.02L8.99663 15.02Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=FilterReduce.js.map